// eslint-disable-next-line @typescript-eslint/no-explicit-any -- This is recursive and queries the type during runtime
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
export var deepFreeze = function(obj) {
    Object.keys(obj).forEach(function(prop) {
        if (_type_of(obj[prop]) === 'object') {
            deepFreeze(obj[prop]);
        }
    });
    return Object.freeze(obj);
};
export function getMinimum(arr, mapToNum) {
    return arr.reduce(function(prev, curr) {
        return mapToNum(prev) < mapToNum(curr) ? prev : curr;
    });
}
export function getMaximum(arr, mapToNum) {
    return arr.reduce(function(prev, curr) {
        return mapToNum(prev) > mapToNum(curr) ? prev : curr;
    });
}
export function typesMatch(a, b) {
    return (typeof a === "undefined" ? "undefined" : _type_of(a)) === (typeof b === "undefined" ? "undefined" : _type_of(b));
}
export function isPrimitive(a) {
    var t = typeof a === "undefined" ? "undefined" : _type_of(a);
    return [
        'string',
        'number',
        'boolean'
    ].indexOf(t) > -1;
}
export function deepEqual(obj1, obj2) {
    var loopNum = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    // If both objects are pointing to the exact same reference, return true and exit early
    if (obj1 === obj2) {
        return true;
    }
    // If either of the objects are of a different type or are null, then return false
    if ((typeof obj1 === "undefined" ? "undefined" : _type_of(obj1)) !== 'object' || (typeof obj2 === "undefined" ? "undefined" : _type_of(obj2)) !== 'object' || obj1 === null || obj2 === null) {
        return false;
    }
    if (loopNum > 5) {
        throw new Error('Max number of iterations reached. This may be due to a circular reference, consider preprocessing before performing this comparison.');
    }
    // Get the keys of both objects.
    var keys1 = Object.keys(obj1);
    var keys2 = Object.keys(obj2);
    // Check if the number of keys is the same.
    if (keys1.length !== keys2.length) {
        return false;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Iterate through the keys and compare their values recursively.
        for(var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key], loopNum + 1)) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // If all checks pass, the objects are deep equal.
    return true;
}

//# sourceMappingURL=object-utils.js.map